import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCourseraComponent } from './simple-icons-coursera.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCourseraComponent ],
    exports:      [ SimpleIconsCourseraComponent ],
    bootstrap:    []
})
export class SimpleIconsCourseraModule {}
